const PURCHASE_TYPES = new Set(['PURCHASE', 'TOP_UP', 'TOPUP', 'PAYMENT', 'TOP_UP_WAYFORPAY']);
const REFERRAL_TYPES = new Set(['REFERRAL_BONUS', 'REFERRAL', 'REFERRAL_REGISTER', 'REFERRAL_PURCHASE', 'REFERRAL_FIRST_TOPUP_BONUS']);
const ACCRUAL_TYPES = new Set(['WELCOME_BONUS', 'ADMIN_CREDIT', 'BONUS', 'CREDIT', 'TIP_CONDUCTOR']);
const GAME_CREATION_TYPES = new Set(['GAME_CREATE', 'GAME_CREATION', 'SESSION_CREATE', 'GAME_CREATE_DEBIT']);
const GAME_EDIT_TYPES = new Set(['GAME_EDIT', 'GAME_EDIT_DEBIT']);

export const transactionCategories = {
  purchase: 'purchase',
  referralBonus: 'referralBonus',
  accrual: 'accrual',
  gameCreation: 'gameCreation',
  gameEdit: 'gameEdit',
  other: 'other',
};

const normalizeType = (value) => String(value || '').trim().toUpperCase();

export const mapTransactionTypeToCategory = (type) => {
  const normalizedType = normalizeType(type);

  if (!normalizedType) {
    return transactionCategories.other;
  }

  if (PURCHASE_TYPES.has(normalizedType)) {
    return transactionCategories.purchase;
  }

  if (normalizedType.startsWith('REFERRAL_PURCHASE') || normalizedType.startsWith('REFERRAL_FIRST_TOPUP_BONUS') || REFERRAL_TYPES.has(normalizedType)) {
    return transactionCategories.referralBonus;
  }

  if (ACCRUAL_TYPES.has(normalizedType)) {
    return transactionCategories.accrual;
  }

  if (GAME_CREATION_TYPES.has(normalizedType)) {
    return transactionCategories.gameCreation;
  }

  if (GAME_EDIT_TYPES.has(normalizedType)) {
    return transactionCategories.gameEdit;
  }

  return transactionCategories.other;
};
